<template lang="pug" src="./custom-about-team.pug"></template>

<script>
import { onScroll } from 'resources/mixins'

export default {
  data () {
    return {
      theWidth: 482,
      containerActive: false,
      options: {
        root: null,
        rootMargin: '0px',
        threshold: [0.2]
      }
    }
  },
  props: {
    props: {
      Type: Object
    },
    tiles: {
      Type: String,
      default: 'three',
      validator: function (str) {
        return ['two', 'three', 'four'].indexOf(str) !== -1
      }
    }
  },
  async created () {
    let clientWidth = setInterval(() => {
      if (this.$el !== undefined) {
        this.theWidth = this.$parent.$el.clientWidth
        clearInterval(clientWidth)
      }
    }, 10)
  },
  mixins: [onScroll],
  methods: {
    onContainerScroll ({going, direction}) {
      if (going === 'in' && direction === 'top') {
        this.containerActive = true
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/custom/custom-about-team/custom-about-team.vue